import { Link } from "react-router-dom";
import { BarChart3, Archive, User, Settings, LogOut, Sparkles } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const items = [
  { to: "/releases", label: "Releases", icon: Sparkles },
  { to: "/statistics", label: "Statistics", icon: BarChart3 },
  { to: "/archive", label: "Archive", icon: Archive },
  { to: "/account", label: "Account", icon: User },
  { to: "/settings", label: "Settings", icon: Settings },
];

export default function Mas() {
  const { user, logout } = useAuth();
  return (
    <div className="p-6 animate-in">
      <h1 className="text-3xl font-bold tracking-tight mb-1">More</h1>
      <p className="text-sm text-zinc-500 mb-6">{user?.display_name} · {user?.email}</p>
      <div className="space-y-2">
        {items.map((it) => (
          <Link key={it.to} to={it.to} data-testid={`more-${it.to.slice(1)}`}
            className="flex items-center gap-3 p-4 rounded-xl bg-[#141416] border border-white/5 hover:border-white/10">
            <it.icon className="w-5 h-5 text-violet-400" />
            <span className="text-sm flex-1">{it.label}</span>
          </Link>
        ))}
        <button onClick={logout} data-testid="more-logout"
          className="w-full flex items-center gap-3 p-4 rounded-xl bg-[#141416] border border-white/5 hover:border-red-500/30 text-red-300">
          <LogOut className="w-5 h-5" />
          <span className="text-sm flex-1 text-left">Log out</span>
        </button>
      </div>
    </div>
  );
}
